/**
 * Orders
 */

// React
import React, {
  useEffect,
  useState,
  useContext,
  FC,
} from 'react';

// Context
import AuthContext, { AuthConsumer } from '../../authContext';

// UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiPackageVariant,
  mdiStateMachine,
  mdiCalendar,
  mdiClose,
  mdiPencilOutline,
  mdiHomeOutline,
} from '@mdi/js';

// Components
import RenderFilter from '../../utils/listDaynamicFilterHookFormMob';
import type { Filter } from '../../utils/listDaynamicFilter';
import List from './warehouseOperatorListMob';
import Pagination from '@material-ui/lab/Pagination';
import Can from '../../components/Can';

// Helper
import {
  removeEmptyValueObject,
  translate,
} from '../../utils/helpers';

// Type
import {
  Props,
  Status,
} from './interfaces';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import useQuery from '../../utils/hook/useQuery';
import { Paper } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import history from '../../utils/history';

// services
import { getOperatorPrint } from '../../api/operator/post';
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    tileBar: {
      zIndex: 10,
      position: 'fixed',
      top: '0px',
      right: '0px',
      display: 'flex',
      width: '100%',
      padding: '8px',
    },
  })
);

const OrdersMob: FC<Props> = (props: Props): React.ReactElement => {
  const [filters, setFilters] = useState([] as Filter[]);
  const authContext = useContext(AuthContext);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 100,
    'status.in': 'ASSIGNED',
    'warehouseType.equals': 'SINGLE',
    'enableGetChildren.equals': true,
    "operatorId.equals": localStorage.getItem("userId")
  } as any);
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false as boolean);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [showList, setShowList] = useState(false);
  const [id, setId] = useState(-1 as number);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [cancelDescription, setCancelDescription] = useState('' as string);
  const [count, setCount] = useState(0);
  const [ordersList, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterTranslator = (fieldName: string) => {
    const status = {
      customerName: 'نام سفارش‌دهنده:',
      'customerName.equals': 'نام سفارش‌دهنده:',
      'customerName.contais': 'نام سفارش‌دهنده:',
      centerName: 'انبار:',
      'centerName.equals': 'انبار:',
      'centerName.contains': 'انبار:',
      id: 'شناسه مرسوله:',
      'id.equals': 'شناسه مرسوله:',
      'id.contains': 'شناسه مرسوله:',
      orderId: 'شناسه سفارش:',
      'orderId.equals': 'شناسه سفارش:',
      'orderId.contains': 'شناسه سفارش:',
      deliveryDate: 'تاریخ تحویل',
      'deliveryDate.equals': 'تاریخ تحویل:',
      'deliveryDate.greaterThanOrEqual': 'تاریخ تحویل:',
      'deliveryDate.greaterThan': 'تاریخ تحویل:',
      'deliveryDate.lessThanOrEqual': 'تاریخ تحویل:',
      'deliveryDate.lessThan': 'تاریخ تحویل:',
      packagedDate: 'تاریخ تحویل به لجستیک:',
      'packagedDate.equals': 'تاریخ تحویل به لجستیک:',
      'packagedDate.greaterThanOrEqual': 'تاریخ تحویل به لجستیک:',
      'packagedDate.greaterThan': 'تاریخ تحویل به لجستیک:',
      'packagedDate.lessThanOrEqual': 'تاریخ تحویل به لجستیک:',
      'packagedDate.lessThan': 'تاریخ تحویل به لجستیک:',
      status: 'وضعیت سفارش:',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
      partnerName: 'شرکت:',
      'partnerName.equals': 'شرکت:',
      'partnerName.contains': 'شرکت:',
      weight: 'وزن:',
      'weight.equals': 'وزن:',
      'weight.contains': 'وزن:',
      length: 'ابعاد:',
      'length.equals': 'ابعاد:',
      'length.contains': 'ابعاد:',
    };
    return status[fieldName];
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };
  const updateOrderStatus = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const { pagination, callback } = await ordersRepository.updateOrderStatus({
        payload,
      });
      callback && callback();
      handleNotfication('تغییر وضعیت سفارش با موفقیت انجام شد', 'success');
    } catch (error) {
      handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getOrders();
    setupFilters();
  }, [filtersValues]);
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };
  const getorder = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const { response, count } = await ordersRepository.getOrders({
        payload,
      });
      setCount(count.data);
      setResponse(response.data);
      if (response.data.length === 1 && response.data[0].status === "ASSIGNED") {
        setFiltersValues({
          page: 0,
          size: 20,
          'status.in': 'ASSIGNED',
          'warehouseType.equals': 'SINGLE',
          'enableGetChildren.equals': true,
          "operatorId.equals": localStorage.getItem("userId")
        })
        history.push(`/orders-mob/${response.data[0].id}`)
      }
    } catch (error) {
      console.log(error)
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getOrders = async () => {
    const { page, size } = filtersValues;
    getorder({
      ...filtersValues,
      page,
      size,
    });
  };
  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'customerName.contains',
        label: 'نام تحویل گیرنده',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'customerMobileNumber.contains',
        label: 'شماره همراه تحویل گیرنده',
        icon: mdiPhoneOutline,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه سفارش',
        icon: mdiPackageVariant,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت سفارش',
        icon: mdiStateMachine,
        data: ['ASSIGNED', 'PICKED', 'PACKAGED'],
        translateType: 'Order',
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.greaterThanOrEqual',
        label: 'تاریخ تحویل از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.lessThanOrEqual',
        label: 'تا تاریخ تحویل ',
        icon: mdiCalendar,
      },
      {
        type: 'checkbox',
        id: 'paymentType.in',
        label: 'شیوه پرداخت',
        icon: mdiStateMachine,
        data: ['COD', 'ONLINE'],
        translateType: 'COD',
      },
    ]);
  };
  let headCells = [];
  Can({
    role: authContext.user.role,
    perform: 'orders:tracking-code',
    yes: () => {
      headCells = [
        { id: 'partnerName', label: 'نام شرکت', type: 'input' },
        {
          id: 'customerName',
          label: 'سفارش‌دهنده',
          type: 'input',
        },
        {
          id: 'id',
          label: 'شناسه سفارش',
          type: 'input',
        },
        {
          id: 'items',
          label: 'تعداد آیتم‌های سفارش',
          type: 'input',
        },
        {
          id: 'deliveryDate',
          label: 'تاریخ تحویل',
          type: 'date-picker',
        },
        { id: 'trackingCode', label: 'کد رهگیری', type: 'input' },
        {
          type: 'checkbox',
          id: 'deliveryType',
          label: 'نوع ارسال',
          data: ['COURIER', 'POST', 'EXPRESS_POST', 'SPECIAL_POST', 'VIP'],
          translateType: 'SendDeliveryType',
        },
        {
          type: 'checkbox',
          id: 'paymentType',
          label: 'شیوه پرداخت',
          data: ['COD', 'ONLINE'],
          translateType: 'COD',
        },
        {
          type: 'checkbox',
          id: 'status',
          label: 'وضعیت',
          data: ['ASSIGNED', 'PICKED', 'PACKAGED'],
          translateType: 'Order',
        },
      ];
    },
    no: () => {
      headCells = [
        { id: 'partnerName', label: 'نام شرکت', type: 'input' },
        {
          id: 'customerName',
          label: 'سفارش‌دهنده',
          type: 'input',
        },
        {
          id: 'id',
          label: 'شناسه سفارش',
          type: 'input',
        },
        {
          id: 'items',
          label: 'تعداد آیتم‌های سفارش',
          type: 'input',
        },
        {
          id: 'deliveryDate',
          label: 'تاریخ تحویل',
          type: 'date-picker',
        },
        {
          type: 'checkbox',
          id: 'status',
          label: 'وضعیت',
          data: ['ASSIGNED', 'PICKED', 'PACKAGED'],
          translateType: 'Order',
        },
      ];
    },
  });
  const head = { headCells };
  const cancelOrder = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const pagination = await ordersRepository.cancelOrder({ payload });
      handleNotfication('سفارش مورد نظر شمابا موفقیت لغو شد', 'success');
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const handleCancelOrder = async () => {
    await cancelOrder({
      id,
      body: { description: cancelDescription },
    });
    getOrders();
    setOpenConfirmCancel(false);
  };
  const changeStatusOrder = () => {
    updateOrderStatus({
      id,
      body: previewState,
      pagination: filtersValues,
    });
    setOpenConfirmUpdateState(false);
  };
  const updateAllOrderStatus = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const pagination = await ordersRepository.updateAllOrderStatus({ payload });
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const changeStatusOrderWhitId = (data: any) => {
    const { ids, status, description } = data;
    updateAllOrderStatus({
      ids,
      status,
      description,
      pagination: filtersValues,
    });
    setOpenConfirmUpdateState(false);
  }
  const handleOpenConfirmUpdateState = (data: { id: number; body: Status }) => {
    setOpenConfirmUpdateState(true);
    setId(data.id);
    setPreviewState(data.body);
  };
  const handleClose = () => {
    setOpenConfirmCancel(false);
    setOpenConfirmUpdateState(false);
  };
  const findOrderStatus = (id: number) => {
    const status = ordersList.find(order => order.id === id)?.status;
    return status && translate(status, 'order');
  };
  const toggleList = () => {
    setShowList(!showList);
  };
  const fetchPickList = async () => {
    await getOperatorPrint({ operatorId: localStorage.getItem("userId") })
    getOrders()
  }
  return (
    <AuthConsumer>
      {({ user }) => (
        <div className={classes.root}>
          <Grid container spacing={2}>
            <Grid container>
              <Paper
                className={classes.tileBar}
              >
                <Grid container xs={12} justifyContent={'center'} alignContent={'center'}>
                  <Typography variant="h6" component="h2">
                    {'لیست سفارش‌ها'}
                  </Typography>

                </Grid>
                <span >
                  <Link to={'/mobile-home'} style={{ justifySelf: 'right' }}>
                    <Icon path={mdiHomeOutline} size={1.2} color={'black'} />
                  </Link>
                </span>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6}>
              <RenderFilter
                filters={filters}
                onFilter={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    page: 0,
                    size: 20,
                    'status.in': 'ASSIGNED, PICKED, PACKAGED',
                    'enableGetChildren.equals': true,
                  });
                }}
                mainFiltersCount={2}
                baseFilter={{
                  type: 'input',
                  id: 'id.equals',
                  placeholder: 'شناسه سفارش',
                }}
                filterValues={filtersValues}
                toggleList={toggleList}
                name={'سفارش ها'}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <>
                  {ordersList.length > 0 ? (
                    <List
                      data={ordersList}
                      changeStatusOrderWhitId={changeStatusOrderWhitId}
                      handleOpenConfirmUpdateState={
                        handleOpenConfirmUpdateState
                      }
                      head={head}
                      filterVal={filtersValues}
                      onFilterValue={(filtervalues: any) => {
                        setFiltersValues({
                          ...removeEmptyValueObject(filtervalues),
                          ...filtersValues,
                          page: 0,
                          size: 10,
                        });
                      }}
                      removeFilterHandler={removeFilterHandler}
                      filterLabelTranslator={filterTranslator}
                    />
                  ) : (
                    <Typography variant="h3" component="div">
                      سفارشی موجود نیست
                    </Typography>
                  )}
                </>
              )}
            </Grid>
            <span style={{ margin:"120px auto auto auto" }}>
              {ordersList.length <= 0 && !loading && <Button variant='contained' size='large' color='primary' onClick={fetchPickList}>
                دریافت پیک لیست جدید
              </Button>}
              <Grid xs={12} sm={6} item direction="row-reverse">
                {ordersList.length > 0 && (
                  <Pagination
                    className={classes.pagination}
                    count={Math.ceil(count / filtersValues.size)}
                    color="secondary"
                    page={filtersValues.page + 1}
                    onChange={handleChangePage}
                  />
                )}

              </Grid>
            </span>

          </Grid>

          <Dialog
            open={openConfirmCancel}
            fullWidth
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                {handleClose ? (
                  <IconButton
                    aria-label="close"
                    // className={classes.closeButton}
                    onClick={handleClose}
                  >
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                ) : null}
              </div>
              <div className={classes.cancelIcon}>
                <Icon
                  path={mdiClose}
                  size={4}
                  color={theme.palette.error.main}
                />
              </div>
              <div
                className={classes.cancelTitle}
              >{`از لغو سفارش با شناسه ${id} مطمئن هستید؟`}</div>
              <TextField
                className={classes.textArea}
                placeholder={'علت لغو...'}
                value={cancelDescription}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setCancelDescription(e.target.value)
                }
              />
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleClose}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {'خیر'}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handleCancelOrder}
                    disabled={!(cancelDescription.length > 0)}
                    size="large"
                  >
                    {'بله'}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>

          <Dialog
            fullWidth
            open={openConfirmUpdateState}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                {handleClose ? (
                  <IconButton
                    aria-label="close"
                    // className={classes.closeButton}
                    onClick={handleClose}
                  >
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                ) : null}
              </div>
              <div className={classes.editIcon}>
                <Icon
                  path={mdiPencilOutline}
                  size={4}
                  color={theme.palette.blue.main}
                />
              </div>
              <div className={classes.cancelTitle}>
                {`از تغییر تگ وضعیت سفارش
                با شناسه  ${id} از
 "${id > -1 && findOrderStatus(id)}"
 به
" ${translate(previewState.replace(/"/g, '') as Status, 'order')}"

 
 
 مطمئن هستید؟`}
              </div>
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleClose}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {'خیر'}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={changeStatusOrder}
                    size="large"
                  >
                    {'بله'}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </AuthConsumer>
  );
};

export default OrdersMob;
